'use client';

import { SessionProvider } from "next-auth/react";

type Props = {
  children: React.ReactNode;
};

export default function AuthProvider({ children }: Props) {
  return (
    <SessionProvider 
      // session={session}
      // Disable automatic polling when tab is focused
      refetchOnWindowFocus={false}
      // Optional: Modify polling interval (in seconds) if you still want periodic checks
      // Default is 0 which means it only updates on focus
      // refetchInterval={0}
    >
      {children}
    </SessionProvider>
  );
}